import jade from 'javascripts/core_post_webpack/sitewide_business_elements/navbar/templates/paper_search_popover.jst.jade';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/navbar/templates/paper_search_popover'
] = jade;
